import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

export const ProtectedRoutes = ({ loginUserRole, userRoles }) => {
  return (
    userRoles?.includes(loginUserRole) ? <Outlet /> : <Navigate to="/" replace/>
  )
}
